import React, { useState } from 'react';

import ConfirmDialog from '../ConfirmDialog';

const ConfirmPublishDialog = ({ bot, isOpen, onClose, onSubmit }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <ConfirmDialog
      title="Você tem certeza que quer publicar essa nova versão do seu Bot?"
      body={
        bot.isActive || bot.type === 'voice' ? (
          ''
        ) : (
          <div>
            <input
              type="checkbox"
              checked={isActive}
              onChange={() => setIsActive(!isActive)}
              className="mr-1"
            />
            O seu bot ainda não está ativo. Você deseja ativar após a publicação
            desta versão?
          </div>
        )
      }
      show={isOpen}
      handleClose={onClose}
      onConfirm={() => onSubmit({ isActive })}
    >
      Você tem certeza que deseja publicar?
    </ConfirmDialog>
  );
};

export default ConfirmPublishDialog;
